// Link mit Tooltip
import {
  Component,
} from "react";
import {
  Link,
} from "react-router-dom";
import {
  Tooltip,
} from "CommonComponents/bricks";
import {
  renderChildren,
} from "CommonCore/router-util";

import _ from "lodash";

export default class TipLink extends Component {
  render() {
    if (this.props.condition === undefined || this.props.condition) {
      // Keine Bedingung oder ist erfüllt
      return <Tooltip overlay={this.props.overlay || "Zur Detailansicht wechseln"}>
        <Link {..._.omit(this.props, "condition")} to={this.props.to}>
          {renderChildren(this.props)}
        </Link>
      </Tooltip>;
    }
      // Bedingung nicht erfüllt, keinen Tooltip und keinen Link liefern
    return <span>{renderChildren(this.props)}</span>;
  }
}


